import api from '@/api/reports';

const actions = {
  FETCH_SESSION_REPORT: async ({ commit, dispatch, state, rootGetters }) => {
    const { organizationId } = rootGetters;
    const {
      dateRange: { start: startDate, end: endDate },
      pageSize,
      currentPage,
      ordering,
      filters: { query: search },
    } = state;
    const offset = currentPage * pageSize;

    const params = {
      organization_id: organizationId,
      limit: pageSize,
      offset,
      ordering,
      search,
      start_date: startDate,
      end_date: endDate,
    };

    dispatch('wait/start', 'sessionReport.fetching', { root: true });

    try {
      const { count, results: report } = await api.fetchSessionReport(params);

      commit('SET_SESSION_REPORT', report);
      commit('SET_COUNT', count);

      return report;
    } finally {
      dispatch('wait/end', 'sessionReport.fetching', { root: true });
    }
  },

  DOWNLOAD_SESSION_REPORT: async ({ state, rootGetters }, { formatType }) => {
    const { organizationId } = rootGetters;
    const {
      dateRange: { start: startDate, end: endDate },
      pageSize,
      currentPage,
      ordering,
      filters: { query: search },
    } = state;
    const fields = state.columns.filter(x => x.showColumn).map(x => x.source_field);

    await api.fetchSessionReport({
      organization_id: organizationId,
      pageSize,
      currentPage,
      ordering,
      search,
      start_date: startDate,
      end_date: endDate,
      format: formatType,
      include: fields,
    });
  },

  CHANGE_PAGE_SIZE: ({ commit, dispatch }, pageSize) => {
    commit('SET_PAGE_SIZE', pageSize);
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_SESSION_REPORT');
  },

  CHANGE_CURRENT_PAGE: ({ commit, dispatch }, { currentPage }) => {
    commit('SET_CURRENT_PAGE', currentPage);
    dispatch('FETCH_SESSION_REPORT');
  },

  CHANGE_ORDERING: ({ commit, dispatch, state }, { ordering }) => {
    if (ordering === state.ordering) {
      return;
    }

    commit('SET_ORDERING', ordering);
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_SESSION_REPORT');
  },

  DATE_RANGE_UPDATE: ({ commit, dispatch }, dateRange) => {
    commit('SET_DATE_RANGE', dateRange);
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_SESSION_REPORT');
  },
};

export default actions;
